import { render, staticRenderFns } from "./AComment.vue?vue&type=template&id=404ffaae&scoped=true&"
import script from "./AComment.vue?vue&type=script&lang=js&"
export * from "./AComment.vue?vue&type=script&lang=js&"
import style0 from "./AComment.vue?vue&type=style&index=0&id=404ffaae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404ffaae",
  null
  
)

export default component.exports